import { defineComponent as _defineComponent } from 'vue'
import Info from '@/components/DynamicInfo.vue';
import { onMounted } from 'vue';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import { useRoute } from 'vue-router/composables';
import { storeToRefs } from 'pinia';
import {
  formatarFontes,
  getLabelDecisao,
  getLabelReferencia,
  getLabelReferenciaNL,
  getTiposVinculacaoDasReferencias,
  getURLArquivoInteriorTeor,
  getURLDownloadDecisao,
  getURLReferencia,
} from '@/utils/legislacaoUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardInformacoesGerais',
  setup(__props) {

const { params } = useRoute();
const store = ConsultaLegislacaoStore();
const { informacoesGeraisLegislacao } = storeToRefs(store);
const info = informacoesGeraisLegislacao;

onMounted(() => {
  store.consultaLegislacao(params.cdLegislacao);
});

return { __sfc: true,params, store, informacoesGeraisLegislacao, info, Info, formatarFontes, getLabelDecisao, getLabelReferencia, getLabelReferenciaNL, getTiposVinculacaoDasReferencias, getURLArquivoInteriorTeor, getURLDownloadDecisao, getURLReferencia }
}

})